import userManagement from '../providers/userManagement';
import parseGroupMetadata from './parseGroupMetadata';

export default function fetchOrgData(user) {
  return new Promise(async (resolve, reject) => {
    const groups = user['https://vrpatients.com/groups'];
    const groupsData = user.groupsData;

    const role = user['https://vrpatients.com/role'];
    if (!groups || !groups.length) {
      reject('User does not belong to an organization');
      return;
    }
    if (role === 'STUDENT') {
      reject('Student cannot retrieve this info');
      return;
    }
    const orgId = groups[0];
    const orgGroup = groupsData[0];

    const [userAccessibleGroups, orgMembers] = await Promise.all([
      ['ADMIN', 'SUPER_ADMIN'].includes(role)
        ? userManagement.get(`/extension/groups/${orgId}/nested`)
        : userManagement.get(`/extension/users/${user.id}/groups`),
      userManagement.getOrgMembers(orgId),
    ]);

    orgGroup.members = orgMembers.map(u => u.user_id);

    const defaultGroups = [
      orgGroup,
      // These are dynamic groups added to the auth0
      // token payload based on the user role
      // Check our auth0 jwt rule in the dashboard
      {
        _id: `${orgId}_ADMINS`,
        name: 'All admins',
        metadata: {},
      },
      {
        _id: `${orgId}_INSTRUCTORS`,
        name: 'All instructors',
        metadata: {},
      },
    ];

    const userGroups = userAccessibleGroups.data
      .map(group => ({
        ...group,
        // Strip the namespacing org id from the group name
        name: group.name.replace(`${orgId}::`, ''),
        metadata: parseGroupMetadata(group),
      }))
      .filter(group => group.metadata.parent === orgGroup._id);

    const orgData = {
      groups: defaultGroups.concat(userGroups),
      users: orgMembers,
    };
    resolve(orgData);
  });
}
